<div class="hgap-4">
  <vitamui-input [formControl]="controlKey" [placeholder]="keyPlaceholder | translate" (blur)="onTouched()" (keydown.enter)="add()">
  </vitamui-input>
  <vitamui-input [formControl]="controlValue" [placeholder]="valuePlaceholder | translate" (blur)="onTouched()" (keydown.enter)="add()">
  </vitamui-input>
  <button type="button" class="btn primary" (click)="add()" [disabled]="buttonAddDisabled()">{{ 'COMMON.ADD' | translate }}</button>
</div>
<div class="vitamui-input-errors">
  <ng-content select="vitamui-common-field-error"></ng-content>
</div>
<div class="vitamui-chip-list mt-1">
  @for (val of values | keyvalue; track val) {
    <div class="vitamui-chip">
      <div class="vitamui-chip-content">{{ val.key }} : {{ val.value }}</div>
      <div class="vitamui-remove-chip" (click)="remove(val.key)">
        <i class="material-icons">clear</i>
      </div>
    </div>
  }
</div>
